import React, { Component } from "react";

import "./css/style.css";
import LoginForm from './LoginForm'

class Login extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <LoginForm />
          </div>
        </div>
      </div>
    );
  }
}
export default Login;
